import { cn } from "@/lib/utils";
import { PlusIcon } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";
import Icon, { ICONS } from "../Core/Icons";
import { Button } from "../ui/button";
import { useNavigate } from "react-router";
import UserMenu from "./UserMenu";

interface Props {
  label?: string;
  hideCreateProject?: boolean;
}

const AppHeader: React.FC<Props> = React.memo((props) => {
  const navigate = useNavigate();
  const projects = useSelector((state: any) => state.supabaseStore.projects);

  return (
    <nav className="border-b px-2 shrink-0 flex items-center justify-between z-[2002] relative h-11">
      <div className="flex-row flex grow justify-between ml-0 my-0">
        <div className="flex flex-1 grow">
          <Icon
            icon={ICONS.TEMPO_LOGO_WHITE}
            className="flex grow-0 w-5 h-5 cursor-pointer mr-2 p-2"
            onClick={(e) => {
              if (
                Object.keys(projects).length === 0 ||
                window.location.pathname.startsWith("/project-create") ||
                window.location.pathname === "/"
              ) {
                return;
              }

              if (e.metaKey || e.ctrlKey) {
                window.open("/", "_blank");
                return;
              }

              navigate("/");
            }}
          />
          <div
            className={cn(
              "text-xs font-normal text-secondary-800",
              !props.label && "hidden"
            )}
          >
            {props.label}
          </div>
        </div>
        <div className="flex-1 flex grow justify-end items-center gap-4">
          <Button
            className={cn(
              "flex items-center gap-1 text-xs h-7 px-2",
              props.hideCreateProject && "hidden"
            )}
            variant="primary"
            onClick={() => {
              navigate("/project-create/workflow-select");
            }}
          >
            <PlusIcon className="w-3 h-3" />
            Create Project
          </Button>
          <UserMenu />
        </div>
      </div>
    </nav>
  );
});

export default AppHeader;
